import React, { useEffect, useState } from "react";

/**
 * Review author avatar with gray initial fallback when photo is missing or fails to load.
 */
const ReviewAuthorAvatar = ({
  author = "",
  photoUrl = null,
  className = "h-10 w-10",
  textClassName = "text-[13px]",
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [photoUrl]);

  const initial = (author || "?").trim().charAt(0).toUpperCase() || "?";
  const showImage = Boolean(photoUrl) && !imageFailed;

  if (showImage) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={`shrink-0 rounded-full object-cover ring-1 ring-[#e5e7eb] ${className}`}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full bg-[#e2e8f0] font-bold text-[#64748b] ${textClassName} ${className}`}
      aria-hidden
    >
      {initial}
    </div>
  );
};

export default ReviewAuthorAvatar;
